import ForgotForm from "../../forms/ForgotForm";

const Forgot = () =>
{
    return <ForgotForm/>
}

export default Forgot;
